import { Dog, Cat, PawPrint } from "lucide-react";

export default function AnimalTypeIcon({ animalType, className }) {
  const Icon = animalType === "Cat" ? Cat : animalType === "Dog" ? Dog : PawPrint;
  return <Icon className={className} />;
}
